module.exports = __webpack_public_path__ + "static/media/Integration.3d0f23b5.jpg";